module.exports = __webpack_public_path__ + "static/media/(V)_MG_5041_-_Pro-Natura_-_Moda_Feminina.a8965a7d.jpg";